module.exports = __webpack_public_path__ + "static/img/guard.957ede63.svg";